import React, { useState, useRef } from "react";
import { isEmail } from "validator";
import AuthService from "../services/auth.service";
import ReCAPTCHA from "react-google-recaptcha";

const BoardRegister = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [password2Error, setPassword2Error] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [recaptchaValidated, setRecaptchaValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const captchaRef = useRef(null);

  const validateEmail = () => {
    if (!email) {
      setEmailError("This field is required!");
    } else if (!isEmail(email)) {
      setEmailError("This is not a valid email.");
    } else {
      setEmailError("");
    }
  };

  const validatePassword = () => {
    if (!password) {
      setPasswordError("This field is required!");
    } else if (password.length < 6 || password.length > 40) {
      setPasswordError("The password must be between 6 and 40 characters.");
    } else {
      setPasswordError("");
    }
  };

  const validatePassword2 = () => {
    if (password !== password2) {
      setPassword2Error("The two passwords must match.");
    } else {
      setPassword2Error("");
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    setMessage("");
    setSuccessful(false);

    if (!emailError && !passwordError && !password2Error && recaptchaValidated) {
      const token = captchaRef.current.getValue();
      captchaRef.current.reset();

      AuthService.register(email, password, honeypot, token)
        .then(() => {
          setMessage("User created! You can now login.");
          setSuccessful(true);
        })
        .catch((error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
          setMessage(resMessage);
          setSuccessful(false);
        });
    } else {
      setMessage("Please validate the reCAPTCHA.");
      setSuccessful(false);
    }
  };

  const handleRecaptchaChange = () => {
    setRecaptchaValidated(true);
  };

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <img 
          src="./avatar_2x.png"
        alt="profile-img" className="profile-img-card" />

        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              className={`form-control ${emailError ? "is-invalid" : ""}`}
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={validateEmail}
            />
            <div className="invalid-feedback">{emailError}</div>
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <label htmlFor="password">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              className={`form-control ${passwordError ? "is-invalid" : ""}`}
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onBlur={validatePassword}
            />
            <i
              className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} eye-icon text-primary`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                top: '43px',
                right: '35px',
                cursor: 'pointer',
                zIndex: 2
              }}
            ></i>
            <div className="invalid-feedback">{passwordError}</div>
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <label htmlFor="password2">Confirm Password</label>
            <input
              type="password"
              className={`form-control ${password2Error ? "is-invalid" : ""}`}
              name="password2"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              onBlur={validatePassword2}
            />
            <i
              className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} eye-icon text-primary`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                top: '43px',
                right: '35px',
                cursor: 'pointer',
                zIndex: 2
              }}
            ></i>
            <div className="invalid-feedback">{password2Error}</div>
          </div>


          <div className="form-group" style={{ display: "none" }}>
            <label htmlFor="honeypot">Leave this field blank</label>
            <input
              type="text"
              className="form-control"
              name="honeypot"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
            <ReCAPTCHA
              sitekey={"6Lde9VErAAAAAAzY6nJ-sT2JZetO5mxtXq_5K2xf"}
              onChange={handleRecaptchaChange}
              ref={captchaRef}
            />
          </div>

          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block">Sign Up</button>
          </div>

          {message && (
            <div className="form-group">
              <div className={successful ? "alert alert-success" : "alert alert-danger"} role="alert">
                {message}
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default BoardRegister;
